/**
 * Wraps inline rich-text content into block-level <p> elements so legacy
 * shapes (bare text with <br><br> separators, or mixed inline + block runs)
 * render identically to content authored in the modern editor.
 *
 * Leaves content alone if it already starts with a block element. Block
 * elements (lists, tables, headings) are passed through unchanged.
 */

const BLOCK_TAGS = new Set(["OL", "UL", "TABLE", "BLOCKQUOTE", "DIV", "H1", "H2", "H3", "H4", "H5", "H6"])

export function normalizeInlineToBlocks(html) {
    if (!html) return html
    if (/^\s*<(p|div|ol|ul|table|blockquote|h[1-6])\b/i.test(html)) return html

    const container = document.createElement("div")
    container.innerHTML = html

    const output = []
    let inlineBuf = []
    let brCount = 0
    let afterBlock = false

    flushAll()
    return output.join("")

    function flushInline() {
        if (!inlineBuf.length) return
        const hasContent = inlineBuf.some((n) => (n.nodeType === 3 ? n.textContent.trim() : n.tagName !== "BR"))
        if (hasContent) {
            const p = document.createElement("p")
            inlineBuf.forEach((n) => p.appendChild(n.cloneNode(true)))
            while (p.firstChild && p.firstChild.nodeName === "BR") p.firstChild.remove()
            while (p.lastChild && p.lastChild.nodeName === "BR") p.lastChild.remove()
            if (p.innerHTML.trim()) output.push(p.outerHTML)
        }
        inlineBuf = []
    }

    function flushAll() {
        for (const node of [...container.childNodes]) {
            if (node.nodeType === 1 && node.tagName === "BR") {
                brCount++
                if (brCount >= 2) {
                    flushInline()
                    output.push("<br>")
                    brCount = 0
                    afterBlock = false
                }
                continue
            }
            if (node.nodeType === 1 && BLOCK_TAGS.has(node.tagName)) {
                flushInline()
                if (brCount === 1) output.push("<br>")
                brCount = 0
                output.push(node.outerHTML)
                afterBlock = true
                continue
            }
            if (brCount === 1) {
                if (afterBlock) output.push("<br>")
                else inlineBuf.push(document.createElement("br"))
            }
            brCount = 0
            afterBlock = false
            inlineBuf.push(node)
        }
        flushInline()
    }
}
